const lockoutNamespaces = ['recoverUser', 'recoverPwd'];
const lockoutKeys = ['resend_attempts', 'resend_lockout', 'buttonDisabled'];

function getAuthPageMarker(page) {
  return document.querySelector(`[data-auth-page="${page}"]`);
}

function clearLockoutState() {
  lockoutNamespaces.forEach((namespace) => {
    lockoutKeys.forEach((key) => {
      localStorage.removeItem(`${namespace}_${key}`);
    });
  });
}

function bindStorageClearingLinks(root) {
  root.querySelectorAll('[data-clear-storage-key]').forEach((link) => {
    link.addEventListener('click', () => {
      const key = link.dataset.clearStorageKey;
      if (!key) {
        return;
      }

      localStorage.removeItem(key);
    });
  });
}

function bindLoadingForms(root) {
  root.querySelectorAll('form[data-auth-submit-loading]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented) {
        return;
      }

      window.Site?.ShowLoading?.();
    });
  });
}

function handleSigninPage() {
  window.Site?.HideLoading?.();
  clearLockoutState();
  bindLoadingForms(document);
}

function handleDefaultAuthPage() {
  window.Site?.HideLoading?.();
  bindLoadingForms(document);
}

function handleRecoverPage(root) {
  window.Site?.HideLoading?.();
  const namespace = root.dataset.resendNamespace;
  const mode = root.dataset.resendMode;
  if (!namespace || !mode || !window.ResendLockout) {
    bindLoadingForms(document);
    return;
  }

  if (mode === 'bootstrap') {
    window.ResendLockout.bootstrapShortLock(namespace);
  } else if (mode === 'reset') {
    window.ResendLockout.reset(namespace);
  }

  // Bind after ResendLockout listeners so prevented submits do not show the loader.
  setTimeout(() => {
    bindLoadingForms(document);
  }, 0);
}

document.addEventListener('DOMContentLoaded', () => {
  bindStorageClearingLinks(document);

  if (getAuthPageMarker('signin')) {
    handleSigninPage();
    return;
  }

  const recoverMarker = getAuthPageMarker('forgot') || getAuthPageMarker('forgotuser');
  if (recoverMarker) {
    handleRecoverPage(recoverMarker);
    return;
  }

  if (!document.querySelector('[data-auth-page]')) {
    return;
  }

  handleDefaultAuthPage();
});
